<template>

  <div class="">
    <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:100vh" variant="dark"
      id="loader">

      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF">
            <HeaderFixed />
          </b-col>
          <b-col cols="12 headerM">
            <HeaderMobile />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-breadcrumb style=" background-color: #e9ecef78;">
              <b-breadcrumb-item href="#home">
                <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                  Home
                </router-link>
              </b-breadcrumb-item>
              <b-breadcrumb-item href="#" active>View Bill</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">View Bill</span>
          </b-col>
        </b-row>
        <hr />
        <div class="paddingLeft30px">
          <b-modal no-close-on-esc no-close-on-backdrop class="modal fade" id="modal-header" hide-footer
            title="Log In to Your Account">
            <div>
              <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm"
                style="z-index:10000;position:absolute" variant="dark" id="loader">



                <br>
                <!-- USER LOGIN-->
                <div id="userDiv" class="showDiv">
                  <label>Enter Mobile Number </label>
                  <b-input-group class="mb-2" style="width:100%;padding-top:0px;padding-bottom:10px;">
                    <b-input-group-prepend is-text>
                      <b-icon icon="phone"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="text" id="mobileNo" value="" name="mobNo" autocomplete="off"
                      placeholder="Mobile Number"></b-form-input>
                  </b-input-group>
                  <span style="display:none;color:red;text-align: center;" id="errorMsg"></span>
                  <div id="sendOtpBtn" style="padding-top:7px;display:block">
                    <b-row>
                      <b-col cols="12">
                        <b-button block @click="sendOtp()" variant="primary">Log In</b-button>
                      </b-col>
                    </b-row>
                  </div>
                  <div id="alreadyLoggedInDiv" style="padding-top:7px; display:none">
                    <b-row>
                      <b-col cols="12" style="color:red;text-align: center;">
                        User is already logged in a different PC.
                        Click on Force Logout to terminate the active session.
                      </b-col>
                    </b-row>
                    <br>
                    <b-row>
                      <b-col cols="12">
                        <b-button block @click="sendOtpFL()" variant="danger">Force Logout</b-button>
                      </b-col>
                    </b-row>
                  </div>

                  <div id="otpDiv" style="display:none">
                    <label>Enter OTP </label>
                    <b-input-group class="mb-2" style="width:100%;">
                      <b-input-group-prepend is-text>
                        <b-icon icon="check2-circle"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input type="text" id="otpNo" autocomplete="off" placeholder="Enter OTP"
                        required></b-form-input>
                    </b-input-group>
                    <span style="color:red;padding-left:40%" id="otpInvalid"> </span>
                    <b-row>
                      <b-col cols="12" offset="">
                        <b-button block variant="primary" @click="loginUser()">Verify OTP & Log In </b-button>
                        <b-button block @click="resendOtp()" variant="outline-primary">Resend OTP</b-button>
                      </b-col>
                    </b-row>
                  </div>
                  <div id="otpDivFL" style="display:none">
                    <label>Enter OTP </label>
                    <b-input-group class="mb-2" style="width:100%;">
                      <b-input-group-prepend is-text>
                        <b-icon icon="check2-circle"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input type="text" id="otpNoFL" autocomplete="off" placeholder="Enter OTP"
                        required></b-form-input>
                    </b-input-group>
                    <span style="color:red;padding-left:40%" id="otpInvalidFL"> </span>
                    <b-row>
                      <b-col cols="12" offset="">
                        <b-button block variant="danger" @click="forceLogout()">Verify OTP & Force Logout </b-button>
                      </b-col>
                    </b-row>
                  </div>
                  <br>
                  <b-row>
                    <b-col cols="12" style="text-align:center">
                      <span>Don't have an Account? <br>
                        <router-link to="/ConsumerRegistration">Register Now</router-link>
                      </span>
                    </b-col>
                  </b-row>
                </div>

                <br><br>
              </b-overlay>
            </div>
          </b-modal>
          <br>
          <b-row class="align-items-center">
            <b-col col cols="12" sm="12" md="8" lg="8" class="d-flex align-items-center">
              <div class="info-notice mr-2">
                <b-icon icon="info-circle-fill" class="info-notice__icon"></b-icon>
                <span class="info-notice__text">
                  To view your bill, kindly <strong>login</strong> to your account.
                </span>
              </div>
              <b-button @click="checkConsumerType()" pill variant="primary" size="md" class="go ml-2">
                Log In
              </b-button>
            </b-col>
          </b-row>

          </br>

          <div id="MobileUpdateDiv" style="display:none">
            <b-row>
              <b-col cols=12>
                <h4 style="color:red"> Unable to send OTP. Mobile Number Not Updated.</h4>
                <a href="MobileUpdate">Click Here to Update Your Mobile Number</a>
              </b-col>
            </b-row>
          </div>
          <div id="BillDiv" class="hideDetails">
            <!-- <b-card header-bg-variant="light" header-text-variant="white" header="Payment Receipt" class="cardStyle">
           -->
            <b-row>
              <b-col cols=12>
                <span class="heading">Bill Details</span>
              </b-col>
            </b-row>

            <b-row class="">
              <b-col col cols="12" sm="12" md="12" lg="12">
                <b-table responsive :items="consumerBill" :fields="consumerBillFields">
                  <template v-slot:cell(due_amt)="data">
                    <span v-html="data.value"></span>
                  </template>
                  <template v-slot:cell(net_amt)="data">
                    <span v-html="data.value"></span>
                  </template>
                  <template v-slot:cell(link)="data">
                    <span v-html="data.value"></span>
                  </template>
                </b-table>
              </b-col>

            </b-row>
            <!-- </b-card> -->
          </div>


        </div>
        <br>
      </b-container>

    </b-overlay>

    <b-modal id="model" centered scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg"> </span>
      <br><br>
      <b-button style="width:8rem" variant="outline-info" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="otpModal" centered no-close-on-esc no-close-on-backdrop title="OTP Verification" hide-footer>
      <b-overlay :show="show1" spinner-variant="primary" spinner-large rounded="sm" style="" variant="dark" id="loader">
        Enter the OTP received in your mobile number <b> {{ consMobile }} </b>
        <b-form-input type="number" id="otp"></b-form-input><br>
        <b-button class="btn" variant="primary" id="success-btn" @click="verifyOtp()">Verify</b-button> &nbsp&nbsp
        <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()">Resend OTP</b-button>
      </b-overlay>
    </b-modal>
  </div>
</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var thColor = '#0288d1';
var mobileNo = "";
var consNo = "";


export default {
  name: '',
  components: {

    'HeaderFixed': HeaderFixed,
    'HeaderMobile': HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      consumerNo: '',
      sdCode: '',
      show: false,
      show1: false,
      consMobile: "",
      consumerBillFields: [
        { key: 'bill_no', label: 'Bill Number', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'bill_date', label: 'Bill Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'due_date', label: 'Due Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'due_amt', label: 'Due Bill Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'center' } },
        { key: 'net_amt', label: 'Net Bill Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'center' } },
        { key: 'link', label: 'Download', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'center' } }
      ],
      consumerBill: []
    }
  },
  methods: {
    sendOtp() {
      var mobile = document.getElementById("mobileNo").value;

      if ((mobile.length != 10)) {
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var parent = this;

      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "new",
        "src": "portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee + '/auth/login',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      this.show = true;

      axios.request(config)
        .then((response) => {
          // console.log(response.data);
          parent.show = false;
          if (response.data.status == "success") {
            parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            document.getElementById("mobileNo").readOnly = true;
            document.getElementById("otpDiv").style.display = "block";
            document.getElementById("sendOtpBtn").style.display = "none";
            document.getElementById("errorMsg").style.display = "none";
          }
          else if (response.data.status == "error" && response.data.message == "already logged in") {
            console.log("exist");
            document.getElementById("mobileNo").readOnly = true;
            document.getElementById("sendOtpBtn").style.display = "none";
            document.getElementById("errorMsg").style.display = "none";
            document.getElementById("alreadyLoggedInDiv").style.display = "block";

          }
          else if (response.data.status == "error") {

            document.getElementById("errorMsg").style.display = "block";
            document.getElementById("errorMsg").innerHTML = response.data.message;

          }
        })
        .catch((error) => {
          console.log(error);
        });

    },
    resendOtp() {
      var parent = this;
      var mobile = document.getElementById("mobileNo").value;
      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "old",
        "src": "portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee + '/auth/login',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      parent.show = true;
      axios.request(config)
        .then((response) => {

          parent.show = false;
          if (response.data.status == "success") {
            parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
          }
          else {
            parent.$bvToast.toast('OTP Could not Sent !', {
              title: `Error`,
              variant: 'danger',
              solid: true
            });
          }
        });
    },
    loginUser() {

      var mobile = document.getElementById("mobileNo").value;
      var otpNo = document.getElementById("otpNo").value;

      if ((mobile.length != 10)) {
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }


      let data = JSON.stringify({
        "mobileNo": mobile,
        "otpNo": otpNo,
        "src": "portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee + '/auth/otp/verify',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      var parent = this;
      this.show = true;
      axios.request(config)
        .then((response) => {
          if (response.data.status == "success") {
            var accessToken = response.data.accessToken;
            sessionStorage.setItem("accessToken", response.data.accessToken);
            sessionStorage.setItem("consList", JSON.stringify(response.data.consList));
            sessionStorage.setItem("mobile", mobile);
            var consNo = response.data.consList[0];
            var consType;

            let data = JSON.stringify({
              "consNo": consNo,
              "mobileNo": mobile
            });

            let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: parent.$urlCommon + '/api/web/auth/getConsDetails',
              headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
              },
              data: data
            };

            axios.request(config)
              .then((response) => {
                parent.show = false;
                console.log(response.data);
                if (response.data.message == "00") {
                  sessionStorage.setItem("selectedCons", consNo);
                  consType = response.data.connType;
                  if (consType == "POSTPAID") {
                    window.location.href = "/website/ConsumerDashboardPostpaid";
                    return false;

                  }
                  else if (consType == "SMART POSTPAID") {
                    window.location.href = "/website/ConsumerDashboardSmartPostpaid";
                    return false;

                  }
                  else if (consType == "PREPAID") {
                    window.location.href = "/website/ConsumerDashboardPrepaid";
                    return false;

                  }
                  else if (consType == "SMART PREPAID") {
                    window.location.href = "/website/ConsumerDashboardSmartPrepaid";
                    return false;

                  }
                }
                else {
                  parent.$bvModal.show('model');
                  document.getElementById("modalMsg").innerHTML = "Consumer Not Found";
                }
              })
              .catch((e) => {
                parent.show = false;
                console.log("Caught :::::::::::::::", e.message);
                if (e.message == "Network Error") {
                  parent.$bvModal.show('redirectModal');
                  document.getElementById("redirectModalMsg").innerHTML = "Session Expired, Please log in again";
                }
              });

          }
          else {
            parent.show = false;
            parent.$bvToast.toast('OTP Invalid !', {
              title: `Failure`,
              variant: 'danger',
              solid: true
            });
          }
        })
        .catch((error) => {
          console.log(error);
          parent.show = false;
          parent.$bvToast.toast('Network Error !', {
            title: `Failure`,
            variant: 'danger',
            solid: true
          });
        });

    },

    sendOtpFL() {
      var mobile = document.getElementById("mobileNo").value;

      if ((mobile.length != 10)) {
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var parent = this;
      this.show = true;

      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "new",
        "src": "portal-fl"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee + '/auth/login',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };


      axios.request(config)
        .then((response) => {
          // console.log(response.data);
          parent.show = false;
          if (response.data.status == "success") {
            parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            document.getElementById("mobileNo").readOnly = true;
            document.getElementById("otpDivFL").style.display = "block";
            document.getElementById("sendOtpBtn").style.display = "none";
            document.getElementById("alreadyLoggedInDiv").style.display = "none";
          }

        })
        .catch((error) => {
          console.log(error);
        });

    },
    forceLogout() {
      var parent = this;
      var mobile = document.getElementById("mobileNo").value;
      var otpNo = document.getElementById("otpNoFL").value;

      let data = JSON.stringify({
        "mobileNo": mobile,
        "otpNo": otpNo,
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee + '/auth/forceLogout',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      parent.show = true;
      axios.request(config)
        .then((response) => {

          parent.show = false;
          if (response.data.status == "success") {
            parent.$bvToast.toast('Force Log Out Successfull. Please Log In now', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            document.getElementById("otpDivFL").style.display = "none";
            document.getElementById("sendOtpBtn").style.display = "block";
            document.getElementById("alreadyLoggedInDiv").style.display = "none";
          }
          else {
            parent.$bvToast.toast('Invalid OTP!', {
              title: `Error`,
              variant: 'danger',
              solid: true
            });
          }
        });
    },
    checkConsumerType() {
      //consNo = document.getElementById("consNo").value;

      //if ((consNo.toString().length != 12)) {
        //this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
          //title: `Alert`,
          //variant: 'danger',
          //solid: true
        //})
        //return;
      //}
      this.$bvModal.show('modal-header')
    },
    // checkConsumerTypeOld() {
    //   var consNo = document.getElementById("consNo").value;
    //   var config = {
    //     method: 'post',
    //     url: this.$urlRestapi + '/RestAPI/checkConsumerType',
    //     headers: {
    //       'Content-Type': 'text/plain'
    //     },
    //     data: consNo
    //   };
    //   var parent = this;
    //   parent.show = true;
    //   axios(config)
    //     .then(function (response) {

    //       parent.show = false;
    //       console.log(response.data);
    //       if (response.data == "smartPrePaid") {
    //         var msgToShow = "This is a Smart Prepaid Consumer.<br><a href='SmartPrepaidBalance' style='text-decoration:underline;font-size:1.4rem'>Click Here</a> to View Smart Prepaid Balance"
    //         document.getElementById("modalMsg").innerHTML = msgToShow;
    //         parent.$bvModal.show("model");
    //         document.getElementById("BillDiv").classList.remove("showDetails");
    //       }
    //       else if (response.data == "prePaid") {
    //         var msgToShow = "This is a Prepaid Consumer.<br> <a href='ReprintVoucher' style='text-decoration:underline;font-size:1.4rem'>Click Here</a> to View Prepaid Voucher"
    //         document.getElementById("modalMsg").innerHTML = msgToShow;
    //         parent.$bvModal.show("model");
    //         document.getElementById("BillDiv").classList.remove("showDetails");
    //       }
    //       else {
    //         parent.sendOtp();
    //       }

    //     })
    //     .catch((e) => {
    //       console.log("Caught", e.message);
    //       parent.show = false;
    //     })

    // },
    // sendOtp() {
    //   var parent = this;

    //   consNo = document.getElementById("consNo").value;

    //   if ((consNo.toString().length != 12)) {
    //     this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
    //       title: `Alert`,
    //       variant: 'danger',
    //       solid: true
    //     })
    //     return;
    //   }
    //   parent.show = true;

    //   axios.post(parent.$urlArms + '/RestAPI/website/otpValidation?consNo=' + consNo)
    //     .then((response) => {

    //       console.log(response.data);
    //       var data = response.data;
    //       var status = data.msg;

    //       if (status == "success") {

    //         if (data.otpGenerated == "Y") {
    //           parent.$bvToast.toast('OTP Sent Successfully !', {
    //             title: `Success`,
    //             variant: 'success',
    //             solid: true
    //           });
    //           parent.$bvModal.show('otpModal');

    //         }
    //         else {
    //           parent.$bvToast.toast('OTP Generation Failed !', {
    //             title: `Failed`,
    //             variant: 'danger',
    //             solid: true
    //           });
    //         }
    //       }
    //       else {
    //         parent.show = false;
    //         parent.$bvModal.show('model');
    //         document.getElementById("modalMsg").innerHTML = "Sorry, Consumer Not Found";
    //       }
    //     })
    //     .catch((e) => {
    //       console.log("Caught", e);
    //       this.show = false;
    //     })
    // },

    // resendOtp() {
    //   var parent = this;
    //   parent.show1 = true;
    //   axios.post(this.$urlArms + "/RestAPI/website/resendOTP?consNo=" + consNo).then(function (response) {
    //     parent.show1 = false;
    //     if (response.data.msg == "success") {
    //       parent.$bvToast.toast('OTP Sent Successfully !', {
    //         title: `Success`,
    //         variant: 'success',
    //         solid: true
    //       });
    //     }
    //     else {
    //       parent.$bvToast.toast('OTP Could not Sent !', {
    //         title: `danger`,
    //         variant: 'danger',
    //         solid: true
    //       });
    //     }
    //   });
    // },

    // verifyOtp() {
    //   var parent = this;
    //   var otp = document.getElementById("otp").value;

    //   parent.show1 = true;
    //   axios.post(parent.$urlCommon + "/api/VerifyOtpViewBill?consNo=" + consNo + "&otp=" + otp).then(function (response) {
    //     parent.show1 = false;
    //     parent.show = false;
    //     //console.log(response.data);

    //     if (response.data.status == "success") {
    //       parent.$bvToast.toast('OTP Verified Successfully !', {
    //         title: `Success`,
    //         variant: 'success',
    //         solid: true
    //       });
    //       parent.$bvModal.hide('otpModal');
    //       document.getElementById("BillDiv").classList.add("showDetails");
    //       var temp = [];


    //       response.data.billData.body.forEach(element => {
    //         // console.log(element);
    //         var res1 = element.bill_DATE.split("-");
    //         var billDateFormatted = res1[2] + "/" + res1[1] + "/" + res1[0];
    //         var res2 = element.due_DATE.split("-");
    //         var dueDateFormatted = res2[2] + "/" + res2[1] + "/" + res2[0];
    //         var dueAmt = "";

    //         if (element.due_AMOUNT == 0) dueAmt = "Paid";
    //         else dueAmt = element.due_AMOUNT;

    //         let subdivision = consNo.substring(0, 3);
    //         let masked = 'x';
    //         let shortCode = 'b' + subdivision + masked + element.bill_NO;

    //         if (response.data.isIRCA) {
    //           var english = `${window.location.origin}/tu/?s=${shortCode}`

    //           var obj = {
    //             "bill_no": element.bill_NO,
    //             "bill_date": billDateFormatted,
    //             "due_date": dueDateFormatted,
    //             "due_amt": "<span style='padding-left:35%'>" + dueAmt + "<span>",
    //             "net_amt": "<span style='padding-left:35%'>" + element.net_AMOUNT + "<span>",
    //             "link": `<img src='${parent.$urlCommon}/assets/pdf-icon-3.png' height='32px' width='32px'/><a target='_blank' href='${english}'>Click Here</a>`
    //           }
    //         } else {



    //           var pdflink = `${window.location.origin}/tu/?s=${shortCode}`;
    //           /* var english = `${window.location.origin}/pdfEngine/v2/energyBill?consNo=${consNo}&billNo=${element.bill_NO}&lang=english`
    //            var assamese = `${window.location.origin}/pdfEngine/v2/energyBill?consNo=${consNo}&billNo=${element.bill_NO}&lang=assamese`*/



    //           var obj = {
    //             "bill_no": element.bill_NO,
    //             "bill_date": billDateFormatted,
    //             "due_date": dueDateFormatted,
    //             "due_amt": "<span style='padding-left:35%'>" + dueAmt + "<span>",
    //             "net_amt": "<span style='padding-left:35%'>" + element.net_AMOUNT + "<span>",
    //             "link": `<img src='${parent.$urlCommon}/assets/pdf-icon-3.png' height='32px' width='32px'/><a target='_blank' href='${pdflink}'>Click Here</a>`
    //           }
    //         }


    //         temp.push(obj);
    //       })
    //       //console.log(temp);
    //       parent.consumerBill = temp;
    //     }
    //     else if (response.data.status == "exception" || response.data.message == "No data for Consumer No") {

    //       document.getElementById("modalMsg").innerHTML = "Sorry, Consumer / Bill Not Found";
    //       parent.$bvModal.show("model");
    //       document.getElementById("BillDiv").classList.remove("showDetails");

    //     }
    //     else {
    //       parent.$bvToast.toast('OTP not Valid !', {
    //         title: `danger`,
    //         variant: 'danger',
    //         solid: true
    //       });
    //       parent.show1 = false;
    //     }
    //   });
    // },
    closeModal() {
      this.$bvModal.hide('model')
    }
  },
  mounted() {
    // axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {

    //            document.getElementById("captcha").src= "data:image/png;base64,"+response.data;

    // })
  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">

.info-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #eef6ff;
  border: 1px solid #cfe4fc;
  border-left: 4px solid #2b8ff0;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 0.85rem;
  line-height: 1.4;
  color: #2c3e50;
}

.info-notice__icon {
  color: #2b8ff0;
  flex-shrink: 0;
  font-size: 1rem;
}

.info-notice__text strong {
  color: #1a4f8a;
}

.blink_me {
  animation: blinker 1s linear infinite;
  font-weight: 600;
}

td {
  padding: 0.3rem;
}

.label {
  font-weight: 600;
}

.data {
  font-weight: 600;
  color: #ff5722;
  font-size: 1.2rem;
}

.hideDetails {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
}

.showDetails {
  visibility: visible;
  opacity: 1;
}

hr {
  margin-top: 5px;
  margin-bottom: 5px;
}

.go:focus {
  box-shadow: none;
}

.paddingRow {
  padding: 0.7rem;
}

.headerF {
  display: block;
}

.headerM {
  display: none;
}

.paddingLeft30px {
  padding-left: 30px;
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }

  .headerM {
    display: block;
  }

  .paddingLeft30px {
    padding-left: 0px;
  }
}
</style>
